import script from "./BookCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookCover.vue?vue&type=script&setup=true&lang=ts"

import "./BookCover.vue?vue&type=style&index=0&id=0ecda440&lang=css"

const __exports__ = script;

export default __exports__